
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"productoFindByParams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codigoBarras"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"depositoId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productoFindByParams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codigoBarras"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codigoBarras"}}},{"kind":"Argument","name":{"kind":"Name","value":"depositoId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"depositoId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nombre"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"marca"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nombre"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"modelo"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nombre"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"tamanio"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tamanio"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"codigoBarras"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"codigoBarrasProveedor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"precio"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"precioCompra"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stock"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stockAlerta"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fechaVencimiento"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"descuentoProveedor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ivaPorcentaje"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"porcentajeSobreCosto"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"otrasCaracteristicas"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":657}};
    doc.loc.source = {"body":"query productoFindByParams($codigoBarras: String, $depositoId: ID) {\n    productoFindByParams(codigoBarras: $codigoBarras, depositoId: $depositoId) {\n        id\n        nombre\n        marca {\n            id\n            nombre\n        }\n        modelo {\n            id\n            nombre\n        }\n        tamanio {\n            id\n            tamanio\n        }\n        codigoBarras\n        codigoBarrasProveedor\n        precio\n        precioCompra\n        stock\n        stockAlerta\n        fechaVencimiento\n        descuentoProveedor\n        ivaPorcentaje\n        porcentajeSobreCosto\n        otrasCaracteristicas\n        createdAt\n        updatedAt\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["productoFindByParams"] = oneQuery(doc, "productoFindByParams");
        
